import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "切捨て" },
  { value: 2, text: "四捨五入" },
  { value: 3, text: "切上げ" },
]);
